import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

function EmailOutboxTestSendModal({
  show,
  onHide,
  testSendDraft,
  testEmail,
  setTestEmail,
  onConfirm,
  sendingTest,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Test Send Email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Send this email to yourself for testing.{' '}
          <strong>The original draft will NOT be marked as sent.</strong>
        </p>

        <div className="mb-3">
          <label className="form-label">Test Recipient Email</label>
          <input
            type="email"
            className="form-control"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
            placeholder="your-email@example.com"
          />
        </div>

        <div className="alert alert-info">
          <strong>Draft Preview:</strong>
          <br />
          To: {testSendDraft?.user_email}
          <br />
          Subject: [TEST] {testSendDraft?.subject}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={onHide} className="btn btn-secondary">
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={!testEmail || sendingTest}
          className="btn btn-primary"
        >
          {sendingTest ? 'Sending...' : 'Send Test'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

EmailOutboxTestSendModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  testSendDraft: PropTypes.shape({
    user_email: PropTypes.string,
    subject: PropTypes.string,
  }),
  testEmail: PropTypes.string.isRequired,
  setTestEmail: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  sendingTest: PropTypes.bool.isRequired,
}

export default EmailOutboxTestSendModal
